<template>
  <b-button
    variant="light"
    class="border-muted"
    v-b-tooltip title="Download as CSV"
    aria-label="Download"
    :disabled="!items?.length"
    @click="saveData"
  >
    <IconDownload class="fill-color" width="1em" height="1em" viewBox="0 0 16 16" aria-hidden="true"/>
  </b-button>
</template>

<script>
import IconDownload from '@primer/octicons/build/svg/download-16.svg'

import { getFullPathExcludingDisplayParams } from '@/pages/manage.vue'
import { datetime } from '@/utils/datetime.js'

export default {
  name: 'DownloadButton',
  components: {
    IconDownload,
  },
  props: {
    items: Array,
  },
  methods: {
    async saveData() {
      const bom = '\ufeff'
      const csv = toCSV(this.items)
      const path = getFullPathExcludingDisplayParams(this.$route).replace('/manage/', '')
      downloadBlob(bom+csv, `${path}.csv`, 'text/csv;charset=utf-8;')
    },
  },
}

function toCSV(data) {
  if (!data?.length) { return }
  const keys = Object.keys(Object.assign({}, ...data)) // union of keys from all items
  const rows = data.map(row => keys.map(key => {
      const val = row[key]
      let result = val
      if (/^\d{4}-\d{2}-\d{2}T/.test(val)) {
        // format dates for excel
        result = datetime(new Date(val), 'iso')
      } else if (Array.isArray(val) && val.every(i => typeof i === 'string')) {
        result = val.join(', ')
      } else if (typeof val === 'object' && val !== null) {
        result = JSON.stringify(val, null, 2)
      } else if (typeof val === 'string' && /\.(jpg|jpeg|gif|png)(\?|$)/.test(val)) {
        // display image urls as images in excel
        result = `=IMAGE("${val}")`
      } else if (typeof val === 'boolean') {
        result = (val) ? '✓' : ''
      }

      if (typeof result === 'string') {
        result = result.replace(/"/g, '""')
        if (result.search(/("|,|\n)/g) >= 0) {
          result = `"${result}"`
        }
      }
      return result
    }).join(','))
    .join('\n')
  return `${keys.join(',')}\n${rows}`
}

/**
 * Download contents as a file
 * Source: https://stackoverflow.com/questions/14964035/how-to-export-javascript-array-info-to-csv-on-client-side
 */
function downloadBlob(content, filename, contentType) {
  // Create a blob
  var blob = new Blob([content], { type: contentType });
  var url = URL.createObjectURL(blob);

  // Create a link to download it
  var pom = document.createElement('a');
  pom.href = url;
  pom.setAttribute('download', filename);
  pom.click();
}
</script>
